import { rest } from "src/common/rest";

import { getApiUrl } from "../api/getUrl";
import { dataParser } from "../dataParser";
import { ZUploadResult, zUploadResult } from "./ZUploadResult";

export const urlFileApi = (path = "") => getApiUrl(`/core/files${path}`);

export const uploadFile = async (
  file: Blob | File,
  isImage: boolean,
): Promise<ZUploadResult> => {
  // Токен авторизации должен передаваться через куки (как и для get)
  // Перешли на rest тк нужен refresh токена авторизации
  const resp = await rest.post(
    urlFileApi(),
    { file },
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
      },
      params: {
        type: isImage ? "IMAGE" : "FILE",
      },
    },
  );

  return dataParser(() => zUploadResult.parse(resp.data), "uploadFile");
};

// Нет смысла в методах для put (т.к. в интерфейсе нет такой операции) и get (т.к. оно должно работать по ссылке)
// удаление тоже пусть на бэке делают
